import { render } from "./ListeProfesseur.vue?vue&type=template&id=6304d260&ts=true"
import script from "./ListeProfesseur.vue?vue&type=script&lang=ts"
export * from "./ListeProfesseur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__